import React, { useState, useEffect } from "react";
import "./innercomponents.scss";
import Popup from "../popup/popup";
function InnerCompnents(props) {
  console.log(props.componentsData);
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState(null);
  const handleChildData = (data) => {
    setShowPopup(data);
  };
  const handlePopup = (data, title) => {
    setShowPopup(!showPopup);
    // console.log("Popup Data:", JSON.parse(data));
    const dataSet = {
      title: title,
      details: JSON.parse(data),
    };

    setPopupData(dataSet);
  };
  return (
    <>
      {showPopup ? (
        <Popup props={popupData} onDataSend={handleChildData} />
      ) : (
        ""
      )}

      <div className="row">
        {props.componentsData.map((res, ind) => {
          return (
            <div className="col-md-3" key={ind}> 
                <div className="card" >
                  <img src={res.thumb} />
                  <div className="card-body">
                    <h5 className="card-title">{res.productName}</h5>
                    {JSON.parse(res.details).length > 0 ? (
                      <button
                        className="btn btn-warning"
                        onClick={() => handlePopup(res.details, res.productName)}
                      >
                        {" "}
                        View Details{" "}
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
            
            </div>
          );
        })}
      </div>
    </>
  );
}

export default InnerCompnents;
